export const getContextualReasons = (challenge: any) => {
    const reasonsByChallenge: { [key: string]: string[] } = {
      'duke-outcome-bias': [
        "The board should focus on results, not process",
        "If it failed, the decision was obviously wrong", 
        "Companies need accountability for bad outcomes"
      ],
      'kahneman-fast-slow': [
        "Most people go with their gut reaction",
        "The obvious answer usually feels right",
        "Quick math seems straightforward"
      ],
      'thaler-endowment': [
        "I just got it, so it's more valuable to me now",
        "I wouldn't want to lose something I own",
        "It feels wrong to sell for the same price"
      ],
      'kahneman-availability': [
        "Shark attacks get way more media coverage",
        "I can easily remember shark attack stories",
        "Airplane parts falling seems extremely rare"
      ]
    }
    
    return reasonsByChallenge[challenge.id] || [
      "Most people go with gut instinct here",
      "This feels like the obvious answer",
      "Initial reaction usually guides the choice"
    ]
  }